// extracted by mini-css-extract-plugin
export default {"button":"themesecondary_button__2krOx"};